import type { IRecord } from '@platform/core/types';

/**
 * Номер запису в списках як у прототипі v4 (стовпець ID, код картки, дошки, рядка розділеного вигляду й підказки календаря): число без
 * префікса типу — «101», а не «TSK-101»; без номера — повне позначення. Доступні назви рядків лишають повне позначення. Чиста функція.
 */
export function recordNumber(record: Pick<IRecord, 'code' | 'display'>): string {
  return Number.isFinite(record.code) && record.code > 0 ? String(record.code) : record.display;
}
